// extracted by mini-css-extract-plugin
export default {"exitButtonWrapper":"ExitButton_exitButtonWrapper__0eRl9"};